<script>
export default {
  props: ['value', 'placeholder']
};
</script>

<template>
  <input 
    class="keepfocus"
    :value="value"
    :placeholder="placeholder"
    v-on:input="$emit('update:input', $event.target.value)"
    type="text">
</template>

<style scoped>
  input
  {
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #161615;
    padding: 14px 12px;
    background: rgba(239, 239, 238, 0.5);
    border-radius: 6px;
    border: 1px solid transparent;
  }

  input:focus
  {
    border: 1px solid #1890D3;
    outline: 5px solid rgba(24, 144, 211, 0.25);
  }
</style>